import { mapDictionaryKey } from "components/Filters/helpers";

import { ModulesSuggestions, SEARCH_MODULES_SUGGESTIONS_DICTIONARY } from "../constants";

export const getFilterKey = (key: ModulesSuggestions | string) => {
  return mapDictionaryKey(key, SEARCH_MODULES_SUGGESTIONS_DICTIONARY);
};
